import { Avatar, Typography } from '@mui/material'
import { FC } from 'react'
import { UserService } from '../services/user'

const UserCard: FC<UserCardProps> = ({ user }) => {
  if (!user) {
    return
  }

  return (
    <Typography
      variant="body2"
      component="div"
      display="flex"
      alignItems="center"
      gap={1}
      color="textSecondary"
    >
      <Avatar
        src={user.profile_picture}
        alt={UserService.getFullName(user)}
        sx={{
          width: '1.75em',
          height: '1.75em',
          fontSize: '0.875em',
        }}
      ></Avatar>
      {UserService.getFullName(user)}
    </Typography>
  )
}

type UserCardProps = {
  user?: Dto.User
}

export { UserCard }
export type { UserCardProps }
